import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';

import './index.css';
import App from './App';
import { installSessionHandling } from './helpers/session';

installSessionHandling();

const themes = {
  dark: `${process.env.PUBLIC_URL}/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/light-theme.css`,
};

const theme = localStorage.getItem('theme');

ReactDOM.render(
  <React.StrictMode>
    {/* No insertionPoint: the theme (which brings antd's base CSS) is appended
        last in <head>, so dev matches production, whose build strips the
        HTML comment an insertion point relies on. */}
    <ThemeSwitcherProvider
      themeMap={themes}
      defaultTheme={theme ? theme : 'light'}
    >
      <App />
    </ThemeSwitcherProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

